import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { deleteSurvey } from '../Services/Surveys.service';
import { useActionToast } from '@/Hooks/useActionToast';

/**
 * Soft delete. The answers survive it on purpose — erasing everyone's at once is `POST /:id/purge`,
 * behind `survey:purge` (R26), which this panel does not expose. Erasing **one** person's is
 * `useDeleteSurveyRespondent`, on the results screen, behind the same permission.
 */
export const useDeleteSurvey = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: (id: string) => deleteSurvey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
      toast.success('Pesquisa excluída', 'As respostas já coletadas continuam guardadas.');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível excluir a pesquisa', error);
    },
  });
};
